import styles from './LeftSideMenu.module.css'
import {ReactNode, useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import useApiQuery from "../ApiQuery/UseApiQuery";
import WaitLoader from "../WaitLoader/WaitLoader";
import {Simulate} from "react-dom/test-utils";
import drop = Simulate.drop;
import {useIsMobile} from "../Util/CheckMobile";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setLoginState} from "../Reducer/GlobalReducer";
interface MenuItemInt
{
    id:number;
    parent:number;
    name:string;
    path: string;
    drop: boolean;
    subMenuCount: number
}

interface MenuDataItem
{
    id:number;
    parent: number;
    path: string
    name: string;
}

interface LeftSideMenuInt
{
    children?: ReactNode
}
export default function LeftSideMenu({children}:LeftSideMenuInt)
{

    const mockData = useRef(null)
    const [ldrLogout,rsLogout,exLogout] = useApiQuery("/auth/logout","get",mockData);


    const dispatch = useDispatch()
    const navigate = useNavigate();
    const isMobile = useIsMobile()
    const containerRef = useRef<HTMLDivElement>(null)

    const mobileMode = useSelector((state: ReduxStateInt) => {
        return state.mobileMode
    })

    const data = useRef({})
    const [ldrData,rsDataItem,executeLoadData] = useApiQuery("/menu/load","get",data);

    const [item, setItem]=useState<MenuDataItem[]>()


    async function loadData()
    {
        const data = await executeLoadData()
        if(data.success ) setItem(data.payload)
    }

    useEffect(()=>{
        loadData().then()
    },[])


    const [menuItem, setMenuItem] = useState<MenuItemInt[]>()
    const [showFullMenu, setShowFullMenu] = useState(true)


    useEffect(()=>{
        setMenuItem( item?.map((item)=>{
            const cnt = getSubMenuCount(item.id) ;
            const sbCount = item.parent===0 ? ( cnt ? cnt: 0 ) : -1
            return {
                ...item,
                drop: false,
                subMenuCount: sbCount
            }
        }))
    },[item])


    const getSubMenuCount = (id:number) =>
    {
        if(item === undefined) return 0;
        return item.reduce((acc,item)=>{
            if(item?.parent === id)acc++
            return acc
        },0)
    }

    const getDropState = (id:number)=>
    {
        return  menuItem?.reduce((acc,item)=>{
            if(item.id === id) acc = item.drop
            return acc
        }, false)
    }

    const setDropState = (id:number, state:boolean)=>
    {
        setMenuItem(menuItem?.map((item)=>{
            if(item.id === id)item.drop = state;
            return item
        }))
    }




    const buildSumMenu = (parent:number)=>{
        if(menuItem === undefined) return null
        const subMenu = menuItem.map((item)=>{
            if(item.parent === parent)
                return(
                    <li key={item?.id}><a className={[styles.linkName].join(' ')} href={undefined}
                        onClick={()=>{
                            navigate(item.path)
                            if(containerRef.current && isMobile)containerRef.current.scrollIntoView()
                        }}
                    >
                        {item?.name}</a></li>
                )
            return null
        })
        return subMenu
    }

    const buildMenu=(level:number)=>{
        if(menuItem === undefined) return null
        const menu = menuItem.map((item)=>{
            if(item?.parent===0 && level===0)
            {
                const drop = getDropState(item?.id)
                return(
                    <li className={[styles.subMenu].join(' ')} key={item?.id} >
                        <div className={styles.firstBlock}
                             onClick={()=>{
                                 setDropState(item?.id,!drop)
                                 if(item.subMenuCount ===0) navigate(item.path)
                             }}
                        >
                            <a href={undefined}>
                                <i className={['bx bx-grid-alt', styles.altGrid].join(' ')}></i>
                                <span className={[styles.linkName].join(' ')}>{item?.name}</span>
                            </a>
                            <i className={['bx bxs-chevron-down arrow ',drop ? styles.dropped : "", item?.subMenuCount<=0 ? styles.hide : "" ].join(' ')}></i>
                        </div>
                        <ul className={[styles.subMenu,styles.blank, (drop ? "" : styles.hide)].join(' ')}>
                            {buildSumMenu(item?.id)}
                        </ul>
                    </li>
                )

            }
        })

        return menu;


    }


    const handleLogout = ()=>{
        exLogout().then(()=>{
            navigate('/')
            dispatch(setLoginState(false))

        })
    }


    return(
        <div className={[styles.sideBarMenuContainer].join(' ')}>


            {
                !showFullMenu &&
                <div className={[styles.sideBarMenuContainer].join(' ')} onClick={()=>setShowFullMenu(true)}>
                    <i className={['bx bx-menu', styles.hideMenu].join(' ')}></i>
                </div>
            }

            <WaitLoader loading={ldrData} api={rsDataItem} onlyLoading={false}>

            {
                showFullMenu &&
                <div className={styles.sideBarMenu}>
                    <ul className={[styles.navLinks].join(' ')}>
                        {buildMenu(0)}
                        <div className={styles.exCont}>
                            <div className={styles.exButton}
                                onClick={handleLogout}
                            >
                                выйти
                            </div>
                        </div>
                        <div className={styles.newWind}><a href={"/lk"} target={"_blank"}>новое окно</a></div>

                    </ul>
                    <div className={styles.hideMenuContainer}
                        onClick={()=>{setShowFullMenu(false)}}
                    >
                        <i className={['bx bx-x', styles.hideMenu].join(' ')}></i>
                    </div>
                </div>
            }
            </WaitLoader>


            <div ref={containerRef} className={[styles.mainContent, showFullMenu ? styles.mainContentShift : ""].join(' ')} style={{height: ldrData ? "400px": undefined}}>
                {children}
            </div>

        </div>
    )
}
